/**
 * 支持多个倒计时容器的通用倒计时逻辑：
 * 1.基础倒计时；
 * 2.mini倒计时；
 * 3.时间线状态更新
 */
function startCountdown(endDate, containerSelector, endText = "------ THIS EVENT HAS ENDED ------") {
  // 获取容器元素
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // 获取时间显示元素
  const daysEl = container.querySelector(".days");
  const hoursEl = container.querySelector(".hours");
  const minutesEl = container.querySelector(".minutes");
  const secondsEl = container.querySelector(".seconds");

  // 获取时间线元素
  const timeline = document.querySelector(".black-friday__timeline");
  const timelineItems = timeline ? timeline.querySelectorAll(".timeline__item") : [];
  
  // 定义两个时间段的日期范围（美国中部时间）
  const timePeriods = [
    {
      start: new Date("2025-11-19T00:00:00-06:00").getTime(),
      end: new Date("2025-11-23T23:59:59-06:00").getTime()
    },
    {
      start: new Date("2025-11-24T00:00:00-06:00").getTime(),
      end: new Date("2025-12-03T23:59:59-06:00").getTime()
    }
  ];
  
  // 更新时间线状态
  function updateTimelineStatus() {
    if (!timeline || timelineItems.length < 2) return;
    
    const now = new Date().getTime();
    const [firstItem, secondItem] = timelineItems;
    const [period1, period2] = timePeriods;// period2对应Nov 24 - Dec 3

    // 获取两个信息盒子元素
    const infoBox = document.querySelector(".black-friday__timeline-info");
    const startInfoBox = document.querySelector(".black-friday__timeline-info-start");
    
    // 移除所有状态类
    timeline.classList.remove("past-first-part", "past-all");
    timelineItems.forEach(item => {
      item.classList.remove("normal", "active", "past");
    });
    
    // 判断第一个时间段状态
    if (now < timePeriods[0].start) {
      // 第一个时间段尚未开始
      firstItem.classList.add("normal");
      secondItem.classList.add("normal");
    } else if (now >= timePeriods[0].start && now <= timePeriods[0].end) {
      // 第一个时间段正在进行
      firstItem.classList.add("active");
      secondItem.classList.add("normal");
    } else if (now > timePeriods[0].end && now < timePeriods[1].start) {
      // 第一个时间段已结束，第二个尚未开始
      firstItem.classList.add("past");
      secondItem.classList.add("normal");
      timeline.classList.add("past-first-part");
    } else if (now >= timePeriods[1].start && now <= timePeriods[1].end) {
      // 第二个时间段正在进行
      firstItem.classList.add("past");
      secondItem.classList.add("active");
      timeline.classList.add("past-first-part");
    } else {
      // 所有时间段已结束
      firstItem.classList.add("past");
      secondItem.classList.add("past");
      timeline.classList.add("past-all");
    }

    // 新增：控制信息盒子的显示/隐藏
    if (infoBox && startInfoBox) {
      // 第二个时间段进行中（Nov 24 - Dec 3）：显示start盒子，隐藏默认盒子
      if (now >= period2.start && now <= period2.end) {
        infoBox.style.display = "none";
        startInfoBox.style.display = "flex"; // 默认是flex
      } else {
        // 其他时间：显示默认盒子，隐藏start盒子
        infoBox.style.display = "flex";
        infoBox.style.opacity = 0.4;
        startInfoBox.style.display = "none";
      }
    }
  }

  // 触发变化的操作
  function triggerChanges() {
    updateTimelineStatus();
  }

  // 初始化时更新时间线状态
  updateTimelineStatus();
  
  // 定时更新时间线状态（每分钟检查一次）
  setInterval(updateTimelineStatus, 60000);

  // 原有倒计时更新逻辑
  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance < 0) {
      // 添加静态结束文案
      const containerChildren = container.children;
      for (let i = 0; i < containerChildren.length; i++) {
        const child = containerChildren[i];
        if (!child.classList.contains('countdown-end-text')) {
          child.style.opacity = '0.05';
        }
      }
      let endElement = container.querySelector('.countdown-end-text');
      if (!endElement) {
        endElement = document.createElement('div');
        endElement.classList.add('countdown-end-text');
        endElement.textContent = endText;
        
        endElement.style.position = 'absolute';
        endElement.style.top = '50%';
        endElement.style.left = '50%';
        endElement.style.transform = 'translate(-50%, -50%)';
        
        container.appendChild(endElement);
      }

      clearInterval(countdownInterval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (daysEl) daysEl.innerText = days.toString().padStart(2, "0");
    if (hoursEl) hoursEl.innerText = hours.toString().padStart(2, "0");
    if (minutesEl) minutesEl.innerText = minutes.toString().padStart(2, "0");
    if (secondsEl) secondsEl.innerText = seconds.toString().padStart(2, "0");
  }

  // 初始化倒计时并启动定时器
  updateCountdown();
  const countdownInterval = setInterval(updateCountdown, 1000);
}

// 美国中部时间 12月3日 23:59:59
const eventEndDate = new Date("2025-12-03T23:59:59-06:00").getTime();

// 启动普通倒计时
startCountdown(eventEndDate, ".countdown-timer-container");

// 启动迷你倒计时
startCountdown(eventEndDate, ".mini-countdown-timer-container");